import { render, staticRenderFns } from "./source_material_button.vue?vue&type=template&id=ae90946e&"
import script from "./source_material_button.vue?vue&type=script&lang=js&"
export * from "./source_material_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports